<template>
    <div v-if="courtMatter" :class="cssClass">
        <b-form-row v-if="details == 'all'">
            <b-form-group label="Matter"
                          label-for="courtMatterDisplayName"
                          class="col-md-6">
                <b-input-group>
                    <b-form-input name="courtMatterDisplayName"
                                  :value="courtMatter.displayName"
                                  readonly>
                    </b-form-input>
                    <b-input-group-append>
                        <b-button variant="outline-secondary" title="Glossary" :href="$urlHelper.getPageUrl('ElectronicGlossary', [courtMatterId])" target="_blank"><i class="fas fa-book mr-1"></i></b-button>
                    </b-input-group-append>
                </b-input-group>                
            </b-form-group>
            <b-form-group label="Court/Tribunal/Other"
                          label-for="courtRegistry"
                          class="col-md-3">
                <b-form-input name="courtRegistry"
                              :value="courtMatter.courtRegistryName"
                              readonly>
                </b-form-input>
            </b-form-group>
            <b-form-group label="Jurisdiction"
                          label-for="courtJurisdiction"
                          class="col-md-3">
                <b-form-input name="courtJurisdiction"
                              :value="courtMatter.courtJurisdictionName"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
        <b-form-row v-if="details == 'med'">
            <b-form-group label="Matter"
                          label-for="courtMatterDisplayName"
                          class="col-md-6">
                <b-form-input name="courtMatterDisplayName"
                              :value="courtMatter.displayName"
                              readonly>
                </b-form-input>
            </b-form-group>
            <b-form-group label="Jurisdiction"
                          label-for="courtJurisdiction"
                          class="col-md-4">
                <b-form-input name="courtJurisdiction"
                              :value="courtMatter.courtJurisdictionName"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
        <b-form-row v-if="details == 'min'">
            <b-form-group label="Jurisdiction"
                          label-for="courtJurisdiction"
                          class="col-md-6">
                <b-form-input name="courtJurisdiction"
                              :value="courtMatter.courtJurisdictionName"
                              readonly>
                </b-form-input>
            </b-form-group>
        </b-form-row>
    </div>
</template>

<script>
    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import Select2 from './Select2';

    Vue.use(BootstrapVue);
    Vue.component('select2', Select2);

    export default {
        name: 'CourtMatterDetails',
        mixins: [ErrorsMixin],
        props: {
            apiUrl: {
                type: String,
                required: true
            },
            courtMatterId: {
                type: String,
                default: null
            },
            cssClass: {
                type: String,
                default: null
            },
            details: {
                type: String,
                default: 'min',
                validator: function (value) {
                    return ['min', 'med', 'all'].includes(value)
                }
            }
        },
        watch: {
            courtMatterId: function () {
                this.reload();
            }
        },
        data: function () {
            return {
                courtMatter: null
            };
        },
        methods: {
            reload: function () {
                var promises = [];
                promises.push(this.reloadMatter());
                return Promise.all(promises);
            },
            reloadMatter: function () {
                var currentErrors = [];
                if (this.courtMatterId != '00000000-0000-0000-0000-000000000000' && this.courtMatterId) {
                    return axios
                        .get(this.apiUrl + '/courtmatter/' + this.courtMatterId)
                        .then(response => {
                            this.courtMatter = response.data;
                        })
                        .catch(ex => {
                            currentErrors = this.handleAxiosException(ex);
                        })
                        .finally(() => {
                            if (currentErrors.length != 0) {
                                this.showErrorsToast(currentErrors);
                            }
                        });
                }
                return Promise.resolve();
            }
        },
        mounted: function () {
            this.reload();
        }
    }
</script>